<template>
    <div class="row mb-4">
        <div class="col-md-4 mb-4">
            <label class="form-label" for="status">Status</label>
            <select class="form-select" id="status" v-model="filters.status">
                <option value="">All</option>
                <option v-for="(status, enumName) in props.invoiceStatuses" :key="enumName" :value="enumName" v-text="status"></option>
            </select>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-md-2">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
        <div class="col-md-4 ms-auto">
            <div class="input-group">
                <input type="text" class="form-control" v-model="searchTerm" placeholder="Search credit note doc number...">
                <span class="input-group-text bg-body border-0">
                    <i class="fa fa-search"></i>
                </span>
            </div>
        </div>
    </div>

    <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm" :filters="filters">
        <template #headings>
            <th v-if="props.hideCustomer === false">Customer</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="invoice_date">Credit Note Date</sortableTh>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="iplicit_doc_no">Doc #</sortableTh>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="gross_amount">Total Gross</sortableTh>
            <th>Status</th>
            <th></th>
        </template>
        <template #rows="{data}">
            <tr v-for="creditNote in data" :key="creditNote.id">
                <td v-if="props.hideCustomer === false">{{ creditNote.customer_name }}</td>
                <td>{{ creditNote.invoice_date }}</td>
                <td>{{ creditNote.iplicit_doc_no }}</td>
                <td>{{ creditNote.gross_amount }}</td>
                <td>{{ creditNote.status }}</td>
                <td v-html="creditNote.actions"></td>
            </tr>
        </template>
    </datatable>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import sortableTh from '@/components/datatable/sortableTh.vue';
import { reactive, ref } from "vue";

const props = defineProps({
    ajaxUrl: String,
    hideCentre: Boolean,
    hideCustomer: Boolean,
    invoiceStatuses: Object,
});

const orderBy = ref('invoice_date');
const orderAsc = ref(false);
const limit = ref(25);
const searchTerm = ref(null);
const filters = reactive({
    status: '',
});

const setOrder = function (input) {
    if (orderBy.value == input) {
        orderAsc.value = ! orderAsc.value;
    } else {
        orderBy.value = input;
        orderAsc.value = true;
    }
};
</script>
